import { Environment as CapsuleEnvironment } from '@usecapsule/web-sdk';
async function buildChainsMap() {
    const chains = await import('viem/chains');
    const chainEntries = Object.entries(chains);
    const chainsMap = new Map();
    for (const [chainName, chainObject] of chainEntries) {
        if (chainObject && 'id' in chainObject) {
            chainsMap.set(chainObject.id, chainObject);
        }
    }
    return chainsMap;
}
function getChainsByIds(chainIds, chainsMap) {
    return chainIds.map(id => chainsMap.get(id)).filter((c) => !!c);
}
function convertChainIdToNumber(chainId) {
    if (typeof chainId === 'number') {
        return chainId;
    }
    const hexRegex = /^[0-9a-fA-F]+$/;
    return hexRegex.test(chainId) ? parseInt(chainId, 16) : Number(chainId);
}
function validateOptions(options, chains, appMetadata) {
    if (!(options.environment in CapsuleEnvironment)) {
        throw new Error(`Invalid environment. Must be one of the Environment enum values.`);
    }
    if (appMetadata == null) {
        throw new Error('No appMetadata passed into the Onboard object');
    }
    if (typeof appMetadata.name !== 'string' || appMetadata.name.trim() === '') {
        throw new Error('appName must be a non-empty string.');
    }
    if (!Array.isArray(chains) || chains.length === 0) {
        throw new Error('chains must be a non-empty array.');
    }
    if (chains.some(chain => typeof Number(chain.id) !== 'number')) {
        throw new Error('All elements in chains must be numbers.');
    }
    if (options.apiKey !== undefined &&
        (typeof options.apiKey !== 'string' || options.apiKey.trim() === '')) {
        throw new Error('apiKey must be a non-empty string.');
    }
}
function capsule(options) {
    return () => {
        return {
            label: 'Capsule',
            getIcon: async () => (await import('./icon')).default,
            getInterface: async ({ chains, appMetadata }) => {
                const { default: Capsule, CapsuleEIP1193Provider } = await import('@usecapsule/web-sdk');
                validateOptions(options, chains, appMetadata);
                const capsule = new Capsule(options.environment, options.apiKey);
                const chainsMap = await buildChainsMap();
                const providerOpts = {
                    capsule: capsule,
                    chainId: convertChainIdToNumber(chains[0].id).toString(),
                    appName: appMetadata === null || appMetadata === void 0 ? void 0 : appMetadata.name,
                    chains: getChainsByIds(chains.map(ch => convertChainIdToNumber(ch.id)), chainsMap)
                };
                const provider = new CapsuleEIP1193Provider(providerOpts);
                provider.disconnect = () => { capsule.logout(); };
                return {
                    instance: capsule,
                    provider: provider
                };
            }
        };
    };
}
export default capsule;
export { CapsuleEnvironment as Environment };
